import { IDeviceTypesIfcInstanceClassesEnum } from "@backend/src/schemas";

export enum DeviceCategoryEnum {
  SUPPLY_AIR_DEVICE = "SUPPLY_AIR_DEVICE",
  CHILLER = "CHILLER_DEVICE",
  RETURN_AIR_DEVICE = "RETURN_AIR_DEVICE",
  LIGHT_DEVICE = "LIGHT_DEVICE",
  LIGHT_DEVICE_CIRCULAR = "LIGHT_DEVICE_CIRCULAR",
  DOWN_LIGHT = "DOWN_LIGHT_DEVICE",
  DEFAULT_DEVICE = "DEFAULT_DEVICE",
  FIRE_SUPPRESSION_DEVICE = "FIRE_SUPPRESSION_DEVICE",
  DOOR = "DOOR",
  WINDOW = "WINDOW",
  FURNITURE = "FURNITURE",
  SENSOR_DEVICE = "SENSOR_DEVICE",
}

export enum IfcClassesEnum {
  IFCFURNITURE = "IfcFurniture",
  IFCCOLUMN = "IfcColumn",
  IFCDOOR = "IfcDoor",
  // IFCWINDOW = "IfcWindow",
  /*
  IFCWALL = "IfcWall",
  IFCWALLSTANDARDCASE = "IfcWallStandardCase",*/
  IFCSENSOR = "IfcSensor",
  IFCAIRTERMINAL = "IfcAirTerminal",
  IFCLIGHTFIXTURE = "IfcLightFixture",
  IFCFIRESUPRESSIONTERMINAL = "IfcFireSuppressionTerminal",
  IFCCHILLER = "IfcChiller",
}

export const IfcClassesTranslations = {
  [IfcClassesEnum.IFCFURNITURE]: "Møbler",
  [IfcClassesEnum.IFCCOLUMN]: "Søyle",
  [IfcClassesEnum.IFCDOOR]: "Dør",
  [IfcClassesEnum.IFCSENSOR]: "Sensor",
  [IfcClassesEnum.IFCAIRTERMINAL]: "Luft",
  [IfcClassesEnum.IFCLIGHTFIXTURE]: "Lysarmatur",
  [IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL]: "Sprinkler",
  [IfcClassesEnum.IFCCHILLER]: "Baffel",
  /* 
  [IfcClassesEnum.IFCWALL]: "Vegg",
  [IfcClassesEnum.IFCWALLSTANDARDCASE]: "Vegg",*/
};

export const IFC_CLASSES_CEILING_DEVICES = Object.freeze([
  IfcClassesEnum.IFCSENSOR,
  IfcClassesEnum.IFCAIRTERMINAL,
  IfcClassesEnum.IFCLIGHTFIXTURE,
  IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL,
  IfcClassesEnum.IFCCHILLER,
]) as readonly IDeviceTypesIfcInstanceClassesEnum[];

export const IFC_CLASSES_COLORS = {
  [IfcClassesEnum.IFCFURNITURE]: "#e4dfcd",
  [IfcClassesEnum.IFCDOOR]: "#6c5959",
  [IfcClassesEnum.IFCSENSOR]: "#bf00ff",
  [IfcClassesEnum.IFCAIRTERMINAL]: "#0080c0",
  [IfcClassesEnum.IFCLIGHTFIXTURE]: "#FFA500",
  [IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL]: "#FF0000",
  [IfcClassesEnum.IFCCOLUMN]: "#000000",
  [IfcClassesEnum.IFCCHILLER]: "#00f1dd",
  /* [IfcClassesEnum.IFCWALL]: "#808080",
  [IfcClassesEnum.IFCWALLSTANDARDCASE]: "#808080",*/
};

export enum DisciplineEnum {
  VENTILATION = "VENTILATION",
  ELECTRICAL = "ELECTRICAL",
  SPRINKLER = "SPRINKLER",
  ARCHITECTURE = "ARCHITECTURE",
  UNKNOWN = "UNKNOWN",
}

type DisciplineDeviceMapping = {
  [key in DeviceCategoryEnum]: DisciplineEnum;
};

export const DEVICE_DISCIPLINE_MAPPING: DisciplineDeviceMapping = {
  [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: DisciplineEnum.VENTILATION,
  [DeviceCategoryEnum.RETURN_AIR_DEVICE]: DisciplineEnum.VENTILATION,
  [DeviceCategoryEnum.LIGHT_DEVICE]: DisciplineEnum.ELECTRICAL,
  [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: DisciplineEnum.ELECTRICAL,
  [DeviceCategoryEnum.DOWN_LIGHT]: DisciplineEnum.ELECTRICAL,
  [DeviceCategoryEnum.SENSOR_DEVICE]: DisciplineEnum.ELECTRICAL,
  [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: DisciplineEnum.SPRINKLER,
  [DeviceCategoryEnum.DEFAULT_DEVICE]: DisciplineEnum.ARCHITECTURE,
  [DeviceCategoryEnum.DOOR]: DisciplineEnum.ARCHITECTURE,
  [DeviceCategoryEnum.WINDOW]: DisciplineEnum.ARCHITECTURE,
  [DeviceCategoryEnum.FURNITURE]: DisciplineEnum.ARCHITECTURE,
  [DeviceCategoryEnum.CHILLER]: DisciplineEnum.VENTILATION,
};

export const DEVICE_CATEGORY_IFC_INSTANCE_MAPPING: {
  [key in DeviceCategoryEnum]: IfcClassesEnum;
} = {
  [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: IfcClassesEnum.IFCAIRTERMINAL,
  [DeviceCategoryEnum.RETURN_AIR_DEVICE]: IfcClassesEnum.IFCAIRTERMINAL,
  [DeviceCategoryEnum.LIGHT_DEVICE]: IfcClassesEnum.IFCLIGHTFIXTURE,
  [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: IfcClassesEnum.IFCLIGHTFIXTURE,
  [DeviceCategoryEnum.DOWN_LIGHT]: IfcClassesEnum.IFCLIGHTFIXTURE,
  [DeviceCategoryEnum.SENSOR_DEVICE]: IfcClassesEnum.IFCSENSOR,
  [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL,
  [DeviceCategoryEnum.DEFAULT_DEVICE]: IfcClassesEnum.IFCFURNITURE,
  [DeviceCategoryEnum.DOOR]: IfcClassesEnum.IFCDOOR,
  [DeviceCategoryEnum.WINDOW]: IfcClassesEnum.IFCDOOR,
  [DeviceCategoryEnum.FURNITURE]: IfcClassesEnum.IFCFURNITURE,
  [DeviceCategoryEnum.CHILLER]: IfcClassesEnum.IFCCHILLER,
};

export type IDeviceTypeSettings = {
  [key in DeviceCategoryEnum]: {
    color: string;
    showDirectionInViewer: boolean;
    label: string; // kort visningsnavn (norsk)
    description?: string; // valgfritt, kan brukes i tooltips / tabeller
  };
};

export const DEVICES_TYPES_SETTINGS: IDeviceTypeSettings = {
  [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: {
    color: "#0080c0",
    showDirectionInViewer: true,
    label: "Tilluft",
    description: "Luftdon klassifisert som tilluft.",
  },
  [DeviceCategoryEnum.RETURN_AIR_DEVICE]: {
    color: "#ffff00",
    showDirectionInViewer: false,
    label: "Avtrekk",
    description: "Luftdon klassifisert som avtrekk eller retur.",
  },
  [DeviceCategoryEnum.LIGHT_DEVICE]: {
    // Kvadratisk
    color: "#FFA500",
    showDirectionInViewer: false,
    label: "Belysning",
  },
  [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: {
    color: "#a36e0c",
    showDirectionInViewer: false,
    label: "Belysning – rund",
  },
  [DeviceCategoryEnum.DOWN_LIGHT]: {
    color: "#becf83",
    showDirectionInViewer: false,
    label: "Downlight",
  },
  [DeviceCategoryEnum.DEFAULT_DEVICE]: {
    color: "#808080",
    showDirectionInViewer: false,
    label: "Øvrige komponenter",
  },
  [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: {
    color: "#FF0000",
    showDirectionInViewer: false,
    label: "Sprinkler",
  },
  [DeviceCategoryEnum.DOOR]: {
    color: "#9e9e9e",
    showDirectionInViewer: false,
    label: "Dører",
  },
  [DeviceCategoryEnum.WINDOW]: {
    color: "#10d5d5",
    showDirectionInViewer: false,
    label: "Vinduer",
  },
  [DeviceCategoryEnum.FURNITURE]: {
    color: "#e4dfcd",
    showDirectionInViewer: false,
    label: "Møbler",
  },
  [DeviceCategoryEnum.SENSOR_DEVICE]: {
    color: "#bf00ff",
    showDirectionInViewer: false,
    label: "Sensorer",
  },
  [DeviceCategoryEnum.CHILLER]: {
    color: "#00f1dd",
    showDirectionInViewer: true,
    label: "Baffel",
  },
};

export enum RIGHT_CLICK_DEVICE_MENU_ENUM {
  DELETE = `Slett (backspace)`,
  COPY = "Kopier (ctrl+c)",
  ROTATE = "Roter (ctrl+r)",
}
